import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function SchoolOrderButton({ school, testid }) {
  return (
    <Link
      to={`/ecole/${school.slug}`}
      data-testid={testid}
      className="inline-flex items-center gap-2 rounded-full bg-amber-deep px-5 py-2.5 text-sm font-medium text-white shadow-md shadow-amber-900/15 transition-colors duration-200 hover:bg-honey"
    >
      <GraduationCap size={16} /> Bon de commande — {school.name}
    </Link>
  );
}

export default function SchoolOrderLink() {
  const { user } = useAuth();
  const [school, setSchool] = useState(null);

  useEffect(() => {
    if (!user?.school_id) return;
    api.get("/customer/children").then(({ data }) => setSchool(data.school)).catch(() => setSchool(null));
  }, [user?.school_id]);

  if (!school?.slug) return null;
  return <div className="mt-4"><SchoolOrderButton school={school} testid="account-school-order-link" /></div>;
}
